module.exports = __webpack_public_path__ + "static/qnsmark-4e27aada106bc7effddb13691c7bff5b.jpg";